export default "__VITE_ASSET__Div51_0A__"